import { Component, OnInit } from '@angular/core';
import { PostService } from 'src/app/Services/Post/post.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';

import {
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faComment,
  faPlusCircle,
  faClosedCaptioning,
  faPencilAlt,
  faSlash,
} from '@fortawesome/free-solid-svg-icons';
import { CommentaireService } from 'src/app/Services/Commentaire/commentaire.service';
import { Post } from 'src/app/Models/Post';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Form,
  FormBuilder,
  NgModel,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertService } from 'src/app/Services/User/alert.service';
import { ToastService } from 'src/app/Services/toast/toast.service';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss'],
})
export class PostsComponent implements OnInit {
  id: any;
  post: any;
  ListPost: any;
  titre: string;
  date: string;
  user: string;
  faThumbsUp = faThumbsUp;
  faThumbsDown = faThumbsDown;
  faTrash = faTrash;
  faPencilAlt = faPencilAlt;
  faComment = faComment;
  nComment: any;
  nPosts: any;
  hideformpost = true;
  hideformupdatepost = true;
  Post: any = {};
  selectedFile: File = null;
  hideimage = true;
  hideform = false;
  hideformupdate = false;
  showmsg = false;
  msg = '';
  closeResult: string;
  faAdd = faPlusCircle;
  style1: string;
  isOpened: boolean;
  toggleStyle: string;
  form: FormGroup;
  // submitted = false;
  faClose = faSlash;
  submitted = false;
  constructor(
    private modalService: NgbModal,
    private postService: PostService,
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private commantaireservice: CommentaireService,
    private toast: ToastService,
    private _shared:PostService,
    private act: ActivatedRoute
  ) {}

  //    get f() { return this.form.controls; }

  ngOnInit(): void {
    this.getAllPosts();
    this.hideSupp(this.id);
    this.hideUpp(this.id);
    this.hideFormPost();
    this.HideFormUpdatePost();
    
    this.form = this.formBuilder.group({
      
      title: ['', Validators.required],
      description: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      numtlf: ['', [Validators.required, this.eightDigit.bind(this)]],
      type: ['', Validators.required],
      image: ['', [Validators.required ]],// Added required and file type validation for the image field
      price: [''],
      state: [''],
      pricePerHour: [''],
      experience: [''],
      impact: [''],
      mainGoal: ['']
    });
     // Add conditional validators
    this.form.get('type').valueChanges.subscribe(value => {
      this.updateFormValidators(value);
    });
    
  }

  //form validators depend on type selection required fields 
  updateFormValidators(value: string) {
    const priceControl = this.form.get('price');
    const stateControl = this.form.get('state');
    const pricePerHourControl = this.form.get('pricePerHour');
    const experienceControl = this.form.get('experience');
    const impactControl = this.form.get('impact');
    const mainGoalControl = this.form.get('mainGoal');

    // Reset validators
    priceControl.setValidators(null);
    stateControl.setValidators(null);
    pricePerHourControl.setValidators(null);
    experienceControl.setValidators(null);
    impactControl.setValidators(null);
    mainGoalControl.setValidators(null);

    if (value === 'product') {
      // Set required validators for Product
      priceControl.setValidators([Validators.required]);
      stateControl.setValidators([Validators.required]);
    } else if (value === 'service') {
      // Set required validators for Service
      pricePerHourControl.setValidators([Validators.required]);
      experienceControl.setValidators([Validators.required]);
    } else if (value === 'project') {
      // Set required validators for Project
      impactControl.setValidators([Validators.required]);
      mainGoalControl.setValidators([Validators.required]);
    }

    // Update validators
    priceControl.updateValueAndValidity();
    stateControl.updateValueAndValidity();
    pricePerHourControl.updateValueAndValidity();
    experienceControl.updateValueAndValidity();
    impactControl.updateValueAndValidity();
    mainGoalControl.updateValueAndValidity();
  }


  eightDigit(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && value.toString().length !== 8) {
      return { 'eightDigit': true };
    }
    return null;
  }
  get f() {
    return this.form.controls;
  }
  openModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'block';
  }

  closeModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'none';
  }
  toggle() {
    this.style1 = 'flex';
    // this.style2="none";
    this.isOpened = true;
    this.toggleStyle = 'flex';
  }
  closeNote() {
    this.style1 = 'none';
    this.isOpened = false;
  }
  onSubmit(){
    this.id = localStorage.getItem('Id');
     this.submitted = true ; 
     // Stop here if the form is invalid
     if (this.form.invalid) {
      return;
    }
    const post ={
      titre: this.f.title.value,
      description: this.f.description.value,
      email: this.f.email.value,
      numtlf: this.f.numtlf.value,
      /*fb : this.f.fb.value , 
      insta : this.f.insta.value, 
      tiktok : this.f.tiktok.value ,
      linked : this.f.linked.value ,  */
      price : this.f.price.value , 
      state : this.f.state.value , 
      pricePerHour : this.f.pricePerHour.value, 
      experience : this.f.experience.value , 
      impact : this.f.impact.value , 
      mainGoal : this.f.mainGoal.value ,
    };

    this.postService.addPost2(post,this.id , this.selectedFile).subscribe(
      data=>{
        this.form.reset();
        console.log("Post added Succeffully ");
        this.toast.SuccessToast("Post Added Successfully !");
        this.router.navigate(['/home/posts']);
      },
      err=>{
        console.error('Error adding opportunity:', err);
        this.toast.ErrorToast("Post not Added");
      }
      
    )
  }
  openalert(contentalert) {
    this.modalService
      .open(contentalert, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  getAllPosts() {
    this.postService.getAllPost().subscribe(
      (data) => {
        this.ListPost = data;
        this.nPosts = this.ListPost.length;
        return this.ListPost;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  setPostId(id: any) {
    sessionStorage.setItem('IdPost', id);
  }

  
  SearchPostByTitre() {
    if (this.titre != '') {
      this.ListPost = this.ListPost.filter((res) => {
        return res.titre.toLowerCase().match(this.titre.toLowerCase());
      });
    } else if (this.titre == '') {
      this.getAllPosts();
    }
  }
  SearchPostByDate() {
    if (this.date != '') {
      this.ListPost = this.ListPost.filter((res) => {
        return res.date.toLowerCase().match(this.date.toLowerCase());
      });
    } else if (this.date == '') {
      this.getAllPosts();
    }
  }
  deletePost() {
    this.postService
      .deletePost(sessionStorage.getItem('IdPost'))
      .subscribe((data) => {
        this.toast.SuccessToast('Your post deleted');
        return data;
      });
  }
  ArcheivePost(){
    this.postService.masquerPost(sessionStorage.getItem("IdPost")).subscribe(
      data=>{
        this.toast.SuccessToast("Post Archeived");
        return data; 
      }
    )
  }

  update() {
    this._shared.updatePost(this.id,this.post,this.selectedFile).subscribe(
      res=>{
        console.log(res);
        this.isOpened= true;
        this.msg ="Post Updated Successfully!"
        this.showmsg = false; 
        this.router.navigate(['/home/posts']);
      },err=>{
        console.log(err);
      }
    )
  }

  updatePost(post: Post, id: any) {
    this.postService.updatePost(post, this.id,this.selectedFile).subscribe((data) => {
      this.msg = 'Post Updated Successfully!';
      this.showmsg = false;
      post = data;
      this.toast.SuccessToast('Your post updated');
      return post;
    });
  }
  hideSupp(id: any) {
    if (id == localStorage.getItem('Id')) {
      return false;
    } else {
      return true;
    }
  }
  hideUpp(id: any) {
    if (id == localStorage.getItem('Id')) {
      return false;
    } else {
      return true;
    }
  }
  CountCommentaireByPostId(id: any) {
    return this.commantaireservice
      .countCommentaireByPostId(id)
      .subscribe((data) => {
        this.nComment = data;
        return this.nComment;
      });
  }

  likePost(id: any) {
    this.postService.likePost(id).subscribe((data) => {
      let hidelike = true;
      let hidedislike = false;
      return data;
    });
  }
  dislikePost(id: any) {
    this.postService.disLikePost(id).subscribe((data) => {
      let hidelike = false;
      let hidedislike = true;
      return data;
    });
  }

  hideFormPost() {
    if (localStorage.length != 0) {
      this.hideformpost = false;
    }
  }
  HideFormUpdatePost() {
    if (localStorage.length != 0) {
      this.hideformupdatepost = false;
    }
  }

  addPost(post: Post) {
    this.id = localStorage.getItem('Id');
    this.postService.addPost(post, this.id).subscribe(
      (data) => {
        post = data;
        this.hideform = true;
        this.hideimage = false;
        sessionStorage.setItem('IdPost', post._id);

        this.router.navigate(['/home/posts']);

        return post;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    console.log(this.selectedFile);
  }
  addImage() {
    this.id = sessionStorage.getItem('IdPost');
    const file = new FormData();
    file.append('image', this.selectedFile, this.selectedFile.name);
    console.log(file);
    this.postService.addImage(file, this.id).subscribe(
      (data) => {
        this.showmsg = false;
        this.toast.SuccessToast('Your post Added !');

        this.router.navigate(['/home/posts']);
        return data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  //scroll up
  topFunction() {
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}
